// src/api/homePageProductsapi.js
import { getErrorMessage } from "../config/errorConfig";
import {
  FEATURED_PRODUCTS_URL,
  PROMOTIONS_URL,
  RECOMMENDED_FOR_YOU_URL,
} from "../config/apiConfig";

const FEATURED_URL = FEATURED_PRODUCTS_URL;
const RECOMMENDED_URL = RECOMMENDED_FOR_YOU_URL;



export const fetchFeaturedProducts = async (page = 1, perPage = 8) => {
  const response = await fetch(FEATURED_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ page, per_page: perPage }),
  });

 if (!response.ok) {
         // Map HTTP status to user-friendly error
         let errorMessage;
         if (response.status >= 500) {
           errorMessage = getErrorMessage("API_SERVER_ERROR");
         } else if (response.status === 404) {
           errorMessage = getErrorMessage("API_NOT_FOUND");
         } else if (response.status === 429) {
           errorMessage = getErrorMessage("API_RATE_LIMITED");
         } else {
           errorMessage = getErrorMessage("API_BAD_REQUEST");
         }
   
         throw new Error(errorMessage);
       }
  const data = await response.json();
  // featured_products is wrapped
  return {
    records: data.featured_products || [],
    pages: data.pages || 1,
  };
};

export const fetchPromotions = async (customerId) => {
   if (!customerId) {
    throw new Error(getErrorMessage("VALIDATION_CUSTOMER_ID_REQUIRED"));
  }
  const response = await fetch(PROMOTIONS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ customer_id: customerId }),
  });
  if (!response.ok) {
         // Map HTTP status to user-friendly error
         let errorMessage;
         if (response.status >= 500) {
           errorMessage = getErrorMessage("API_SERVER_ERROR");
         } else if (response.status === 404) {
           errorMessage = getErrorMessage("API_NOT_FOUND");
         } else if (response.status === 429) {
           errorMessage = getErrorMessage("API_RATE_LIMITED");
         } else {
           errorMessage = getErrorMessage("API_BAD_REQUEST");
         }
   
         throw new Error(errorMessage);
       }
  const data = await response.json();
  // promotions is wrapped in { promotions: [...] }
  return data.promotions || []; // ← FIX: extract the array
};

export const fetchRecommendedForYou = async (customerId) => {
  if (!customerId) {
    throw new Error(getErrorMessage("VALIDATION_CUSTOMER_ID_REQUIRED"));
  }
  const response = await fetch(RECOMMENDED_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ customer_id: customerId }),
  });
   if (!response.ok) {
         // Map HTTP status to user-friendly error
         let errorMessage;
         if (response.status >= 500) {
           errorMessage = getErrorMessage("API_SERVER_ERROR");
         } else if (response.status === 404) {
           errorMessage = getErrorMessage("API_NOT_FOUND");
         } else if (response.status === 429) {
           errorMessage = getErrorMessage("API_RATE_LIMITED");
         } else {
           errorMessage = getErrorMessage("API_BAD_REQUEST");
         }
   
         throw new Error(errorMessage);
       }
  const data = await response.json();
  // Check if recommended_for_you is also wrapped!
  // If it returns { recommended_for_you: [...] }, use:
  // return data.recommended_for_you || [];
  // But if it returns a raw array, keep as is.
  return Array.isArray(data) ? data : data.recommended_for_you || [];
};